// Load the initial configuration of the application,
// and parse all window['__what_ever__'] global variables.

// since config.action_controller.asset_host isn't set during build time,
// webpacker cant compute the asset names including the asset_host/CDN
// in rails we set the __webpack_public_path__ at runtime so the client
// can resolve assets on the fly with their absolute CDN path

// https://webpack.js.org/guides/public-path/#on-the-fly

// eslint-disable-next-line no-undef
__webpack_public_path__ = `${window.asset_host}/packs/`;

import '../config/app-config';
